import React, {useEffect, useState} from 'react';
import {GiftSmall} from '@wix/wix-ui-icons-common/on-stage';
import {SummaryDataHooks} from '../AsideSummary/AsideSummary';
import {CodeInputSection} from '../CodeInputSection/CodeInputSection';
import {useLocaleKeys} from '../../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../../Widget/ControllerContext';

export enum GiftCardInputDataHooks {
  enterACodeButtonDisabledTooltip = 'GiftCardInput.enterACodeButtonDisabledTooltip',
}

export const GiftCardInput: React.FC<{mobilePosition?: string}> = ({mobilePosition}) => {
  const localeKeys = useLocaleKeys();

  const {
    cartSummary,
    cart,
    applyGiftCard,
    removeGiftCard,
    applyGiftCardError,
    onAddGiftCardSectionOpen,
    isGiftCardUpdating,
  } = useControllerProps().checkoutStore;
  const [giftCardCodeError, setGiftCardCodeError] = useState(
    applyGiftCardError ? applyGiftCardError.description : undefined
  );

  useEffect(() => {
    const error = applyGiftCardError ?? cartSummary?.errors?.giftCardError;
    setGiftCardCodeError(error ? error.description : undefined);
  }, [cartSummary, applyGiftCardError, localeKeys]);

  const handleCodeInputOpen = () => {
    onAddGiftCardSectionOpen(mobilePosition);
  };

  const handleApplyGiftCard = (giftCardCode: string) => {
    void applyGiftCard(giftCardCode, mobilePosition);
  };

  const handleRemoveCode = () => {
    void removeGiftCard(mobilePosition);
  };

  const enterACodeButtonDisabledTooltipData = {
    dataHook: GiftCardInputDataHooks.enterACodeButtonDisabledTooltip,
    content: localeKeys.checkout.paymentDetails.redeemGiftCard.cantPurchaseGC.tooltip(),
  };
  return (
    <CodeInputSection
      dataHook={SummaryDataHooks.giftCardSectionInput}
      enterACodeButtonText={localeKeys.checkout.paymentDetails.redeemGiftCard.checkbox.label()}
      onCodeInputOpen={handleCodeInputOpen}
      applyCodeText={localeKeys.checkout.paymentDetails.enterGiftCard.CTA()}
      removeCodeText={localeKeys.checkout.paymentDetails.enterGiftCard.remove()}
      codeValue={cart.paymentInfo.giftCard?.obfuscatedCode}
      isLoading={!cartSummary}
      onApplyCode={handleApplyGiftCard}
      onRemoveCode={handleRemoveCode}
      error={giftCardCodeError}
      icon={<GiftSmall />}
      placeholder={localeKeys.checkout.paymentDetails.enterGiftCard.placeholder()}
      isUpdating={isGiftCardUpdating}
      isEnterACodeButtonDisabled={cart.hasGiftCardItems}
      enterACodeButtonDisabledTooltipData={enterACodeButtonDisabledTooltipData}
      ariaLabel={localeKeys.checkout.giftCard.inputCode.ariaLabel()}
    />
  );
};
